module.exports = __webpack_public_path__ + "img/turks-and-caicos-islands.eb157fb0.svg";